import { render, staticRenderFns } from "./PageChargeXhcdHistory.vue?vue&type=template&id=5ae65f8e"
import script from "./PageChargeXhcdHistory.vue?vue&type=script&lang=js"
export * from "./PageChargeXhcdHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports